// The categories of an appointment, as the api stores them: the colour of its
// tag, of the bar beside it and of its block in the planning. Labels live in the locales
// (eventCategories.<category>.label, and .title for a row of the tasks).
export const EVENT_CATEGORIES = {
  prospection: { tag: 'bg-yellow-50 text-yellow-700', bar: 'bg-yellow-500', block: 'bg-yellow-50' },
  visite_client: { tag: 'bg-green-50 text-green-700', bar: 'bg-green-500', block: 'bg-green-50' },
  rdv_client: { tag: 'bg-blue-50 text-blue-700', bar: 'bg-blue-600', block: 'bg-blue-50' },
  embauche: { tag: 'bg-amber-50 text-amber-700', bar: 'bg-amber-500', block: 'bg-amber-50' },
  presentation: { tag: 'bg-[#d9ddff] text-[#303f9f]', bar: 'bg-[#303f9f]', block: 'bg-[#d9ddff]' },
  telephone: { tag: 'bg-[#dde7ec] text-[#455a64]', bar: 'bg-[#455a64]', block: 'bg-[#dde7ec]' },
  interne: { tag: 'bg-gray-100 text-gray-700', bar: 'bg-gray-400', block: 'bg-gray-100' },
};

// Internal meetings show their own title: the others show the company.
export const INTERNAL_CATEGORY = 'interne';

export const eventCategoryOf = (category) =>
  category in EVENT_CATEGORIES ? category : INTERNAL_CATEGORY;

export const eventCategoryText = (language, category, field) =>
  language.getValue(
    `eventCategories.${eventCategoryOf(category)}.${field}`,
    '',
  );
